import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useQuery } from '@sopranodesign/pulse-hooks';

const isValid = (subject, integrations) => {
  if (!subject.integration_id) {
    return true;
  }

  const integration = integrations.find(
    ({ id }) => id === subject.integration_id
  );

  if (!integration) {
    return false;
  }

  if (
    subject.endpoint_id &&
    !integration.endpoints.some(({ id }) => id === subject.endpoint_id)
  ) {
    return false;
  }

  return true;
};

const IntegrationValidator = ({ subject, onValidityChange }) => {
  const { data, isSuccess } = useQuery({
    queryKey: [
      'integrations'
    ]
  });

  useEffect(() => {
    if (!isSuccess) {
      return;
    }

    onValidityChange(isValid(subject, data.data));
  }, [isSuccess, data, subject, onValidityChange]);

  return null;
};

IntegrationValidator.propTypes = {
  subject: PropTypes.object.isRequired,
  onValidityChange: PropTypes.func.isRequired
};

export default IntegrationValidator;
